import { Injectable } from '@angular/core';
import { URL_API } from '../global/config';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs'
import { IFicha } from '../models/IFicha';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FichaService {

  private urlEndpoint: string = URL_API.UrlApiSisCatalogacion+'/api_cata/v1/fichaficha/inner';
  private httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(
    private http: HttpClient
  ) { }

  traerFichaArquitectonica(nroficha: string): Observable<IFicha>{
    //return this.http.get<IFicha>(`${this.urlEndpoint}/${nroficha}`);
    return this.http.get(this.urlEndpoint+'/'+nroficha).pipe(
      map(response => response as IFicha)
    )
  }

}
